<form [formGroup]="form" class="flex flex-col gap-4">
  @if (kind() === 'basicsName') {
    <mat-form-field>
      <input matInput cdkFocusInitial formControlName="name" [placeholder]="'field.name' | translate" />
      <mat-error [control]="form.get('name')" />
    </mat-form-field>
  }

  @if (kind() === 'basicsNotes') {
    <app-campaign-notes [form]="form" />
  }

  @if (kind() === 'basicsBudget') {
    <app-campaign-finance [form]="form" />
  }
</form>
